import React from 'react';
import {
  useParams, useHistory,
} from 'react-router-dom';

import urlHash from '../../utils/functions/urlHash';

import KpiCreate from '../../components/KpiCreate';

export default function KpiCreatePage() {
  const history = useHistory();
  const { hash } = useParams();

  const getParams = () => {
    const str = urlHash(hash, true).split('/');
    return { dashboardKey: str[0], kpiKey: str[1] };
  };
  const { dashboardKey, kpiKey } = getParams();

  return (
    <>
      <KpiCreate
        dashboardKey={dashboardKey}
        goBack={() => history.goBack()}
        kpiKey={kpiKey}
        history={history}
      />
    </>
  );
}
